
exports.ById = {
  1: { Id: 1, Name: 'In Progress', Localization: 'in-progress' },
  2: { Id: 2, Name: 'In Review', Localization: 'in-review' },
  3: { Id: 3, Name: 'Complete', Localization: 'complete' }
};
  
exports.ByName = {
  InProgress: { Id: 1, Name: 'In Progress', Localization: 'in-progress' },
  InReview: { Id: 2, Name: 'In Review', Localization: 'in-review' },
  Complete: { Id: 3, Name: 'Complete', Localization: 'complete' }
};
  